import LevelService from '../../../../services/level_service';

const Updates = (props) => {
  const saveChangeLevels = async () => {
    props.setLoading(true);
    const lostAccess = await props.losesAccess?.();
    if (lostAccess) {
      props.setLoading(false);
      return;
    }
    if (props.levels.some(l => Number(l.Minimum) > Number(l.Maximum))) {
      props.message("Valor mínimo debe ser menor que el valor máximo", "error");
      props.setLoading(false)
      return;
    }
    if(hasOverlap) {
      props.message("Los rangos de niveles se solapan entre sí", "error");
      props.setLoading(false)
      return;
    }
    const levelsToSave = props.levels.map((level, index) => ({
      ...level,
      NumberLevel: index + 1,
      EquivalentActivities: level.EquivalentActivities.length > 0 ?
      (level.EquivalentActivities)
        .map(act => act.text?.trim())
        .filter(text => text)
        .join('-') : null
    }));
    const levelsUpdate = levelsToSave.filter(l => !l.Id.startsWith('temp'))
    const levelsCreate = levelsToSave.filter(l => l.Id.startsWith('temp')).map(({ Id, ...rest }) => rest);
    try {
      const hasUpdates = levelsUpdate.length > 0;
      const hasCreates = levelsCreate.length > 0;
      if (!hasUpdates && !hasCreates) {
        props.message("No hay cambios para guardar", "info");
        return;
      }
      if (hasUpdates) {
        const updates = await LevelService.updates(levelsUpdate);
        if (props.logout(updates)) return;
      }
      if (hasCreates) {
        const creates = await LevelService.creates(levelsCreate);
        if (props.logout(creates)) return;
      }
      props.message("Niveles actualizados con exito", "success");
    } catch(e) {
      props.message(e?.message || e, "error")
    } finally {      
      await props.loadLevels()
    }
  }

  const hasOverlap = props.levels.some((current, i) => {
    const currentMin = Number(current.Minimum);
    const currentMax = Number(current.Maximum);
    return props.levels.some((other, j) => {
      if (i === j) return false;
      const otherMin = Number(other.Minimum);
      const otherMax = Number(other.Maximum);
      return currentMin <= otherMax && currentMax >= otherMin;
    });
  });

  return {saveChangeLevels};
}

export default Updates;
